import { StrapiMenuGetQuery } from './StrapiMenu.query.generated';

export type SubItem = {
  id: string;
  title: string;
  url: string;
  subtitle?: string;
  target?: string;
  icon?: string;
};

export type MainItem = {
  id: string;
  title: string;
  url: string;
  items?: SubItem[];
};

export const normalize = (data?: StrapiMenuGetQuery) => {
  const menu = data?.menus?.[0];

  if (!menu) {
    return undefined;
  }

  const items = menu.menu?.reduce<MainItem[]>((acc, mainItem) => {
    if (mainItem && mainItem.__typename !== 'Error') {
      acc.push({
        id: mainItem.id,
        title: mainItem.title!,
        url: mainItem.url!,
        items: mainItem.items?.reduce<SubItem[]>((acc, subItem) => {
          if (subItem) {
            acc.push({
              id: subItem.id,
              title: subItem.title!,
              url: subItem.url!,
              subtitle: subItem.subtitle,
              target: subItem.target,
              icon: subItem.icon,
            });
          }
          return acc;
        }, []),
      });
    }

    return acc;
  }, []);

  return {
    id: menu.documentId!,
    slug: menu.slug,
    items,
  };
};

export type StrapiMenu = ReturnType<typeof normalize>;
